import { useMemo, useContext } from 'react';

import FormFieldGroupContext from './FormFieldGroupContext';

export const useFormFieldGroupState = ({ active, name, disabled }) => {
  const { getName, isActive, isDisabled } = useContext(FormFieldGroupContext);

  return useMemo(
    () => ({
      name: getName(name),
      active: isActive(active),
      disabled: isDisabled(disabled),
    }),
    [getName, isActive, isDisabled, active, name, disabled]
  );
};
